import http from "../../helpers/http";
import * as helpers from "../../helpers/api";
import { toast } from "react-toastify";
import { TOAST_SETTINGS } from "../../utils/siteSettings";
import Text from "../../components/common/Text";

import {
  FETCH_SINGLE_PROMOTION_CONTENT,
  FETCH_SINGLE_PROMOTION_CONTENT_SUCCESS,
  FETCH_SINGLE_PROMOTION_CONTENT_FAILED,
  SINGLE_PROMOTION_MESSAGE,
  SINGLE_PROMOTION_MESSAGE_SUCCESS,
  SINGLE_PROMOTION_MESSAGE_FAILED,
  FETCH_PROMOTION_CONTENT,
  FETCH_PROMOTION_CONTENT_FAILED,
  FETCH_PROMOTION_CONTENT_SUCCESS,
  PROMOTION_DELETE__MESSAGE,
  PROMOTION_DELETE_MESSAGE_SUCCESS,
  PROMOTION_DELETE__MESSAGE_FAILED,
  GET_FILTER_PROMOTION,
  GET_FILTER_PROMOTION_FAILED,
  GET_FILTER_PROMOTION_SUCCESS,
  FIND_EXISTING_PROMOTION,
  FIND_EXISTING_PROMOTION_SUCCESS,
  FIND_EXISTING_PROMOTION_FAILED,
  EMPTY_STATUS_VALUE,
} from "./actionTypes";

export const fetchPromotions = () => (dispatch) => {
  dispatch({
    type: FETCH_PROMOTION_CONTENT,
    payload: null,
  });
  http
    .get("promotions")
    .then(({ data }) => {
      dispatch({
        type: FETCH_PROMOTION_CONTENT_SUCCESS,
        payload: data,
      });
    })
    .catch((error) => {
      dispatch({
        type: FETCH_PROMOTION_CONTENT_FAILED,
        payload: error,
      });
    });
};
export const fetchSinglePromotion = (PROMOTION_id) => (dispatch) => {
  dispatch({
    type: FETCH_SINGLE_PROMOTION_CONTENT,
    payload: null,
  });
  http
    .get("single-promotion/" + PROMOTION_id)
    .then(({ data }) => {
      //
      dispatch({
        type: FETCH_SINGLE_PROMOTION_CONTENT_SUCCESS,
        payload: data,
      });
    })
    .catch((error) => {
      dispatch({
        type: FETCH_SINGLE_PROMOTION_CONTENT_FAILED,
        payload: error,
      });
    });
};

export const postPromotion = (formData, PROMOTION_id) => (dispatch) => {
  //
  let postUrl = "";
  if (PROMOTION_id != undefined && PROMOTION_id !== null) {
    postUrl = "edit-promotion/" + PROMOTION_id;
  } else {
    postUrl = "add-promotion";
  }
  dispatch({
    type: SINGLE_PROMOTION_MESSAGE,
    payload: null,
  });
  http
    .post(postUrl, helpers.doObjToFormData(formData))
    .then(({ data }) => {
      if (data.status) {
        toast.success(`${data.msg}`, TOAST_SETTINGS);
        setTimeout(() => {
          window.location.replace("/promotions");
        }, 2000);
        dispatch({
          type: SINGLE_PROMOTION_MESSAGE_SUCCESS,
          payload: data,
        });
      } else {
        toast.error(<Text string={data.msg} parse={true} />, TOAST_SETTINGS);
        dispatch({
          type: SINGLE_PROMOTION_MESSAGE_FAILED,
          payload: null,
        });
      }
    })
    .catch((error) => {
      dispatch({
        type: SINGLE_PROMOTION_MESSAGE_FAILED,
        payload: error,
      });
    });
};

export const deletePromotion = (formData) => (dispatch) => {
  dispatch({
    type: PROMOTION_DELETE__MESSAGE,
    payload: null,
  });
  http
    .post("delete-promotion/" + formData, helpers.doObjToFormData(formData))
    .then(({ data }) => {
      if (data.status) {
        toast.success(`${data.msg}`, TOAST_SETTINGS);
        setTimeout(() => {
          window.location.replace("/promotions");
        }, 2000);
        dispatch({
          type: PROMOTION_DELETE_MESSAGE_SUCCESS,
          payload: data,
        });
      } else {
        toast.error(<Text string={data.msg} parse={true} />, TOAST_SETTINGS);
        dispatch({
          type: PROMOTION_DELETE__MESSAGE_FAILED,
          payload: null,
        });
      }
    })
    .catch((error) => {
      dispatch({
        type: PROMOTION_DELETE__MESSAGE_FAILED,
        payload: error,
      });
    });
};
export const getFilteredPromotions = (formData) => (dispatch) => {
  dispatch({
    type: GET_FILTER_PROMOTION,
    payload: null,
  });
  http
    .post("promotions", helpers.doObjToFormData(formData))
    .then(({ data }) => {
      if (data.status) {
        dispatch({
          type: GET_FILTER_PROMOTION_SUCCESS,
          payload: data,
        });
      } else {
        toast.error(<Text string={data.msg} parse={true} />, TOAST_SETTINGS);

        dispatch({
          type: GET_FILTER_PROMOTION_FAILED,
          payload: null,
        });
      }
    })
    .catch((error) => {
      dispatch({
        type: GET_FILTER_PROMOTION_FAILED,
        payload: error,
      });
    });
};
export const getExistingPropertyPromotion = (formData) => (dispatch) => {
  dispatch({
    type: FIND_EXISTING_PROMOTION,
    payload: null,
  });
  http
    .post("find-existing-promotion", helpers.doObjToFormData(formData))
    .then(({ data }) => {
      if (data.status) {
        dispatch({
          type: FIND_EXISTING_PROMOTION_SUCCESS,
          payload: data,
        });
      } else {
        toast.error(<Text string={data.msg} parse={true} />, TOAST_SETTINGS);

        dispatch({
          type: FIND_EXISTING_PROMOTION_FAILED,
          payload: null,
        });
      }
    })
    .catch((error) => {
      dispatch({
        type: FIND_EXISTING_PROMOTION_FAILED,
        payload: error,
      });
    });
};
export const emptyStatusValue = () => (dispatch) => {
  dispatch({
    type: EMPTY_STATUS_VALUE,
  });
};
